<h2>Heart Tones</h2>

<assessment-row title="Irregular Pulse">
  <p>{{ isIrregularPulse }}</p>
</assessment-row>

<assessment-row title="Heart Tones">
  <p>{{ data.heartTones }}</p>
</assessment-row>

<assessment-row title="Rhythm">
  <p>{{ data.rhythm }}</p>
</assessment-row>

<h2>Edema</h2>

<assessment-row title="Presence of JVD">
  <p>{{ isJVDPresent }}</p>
</assessment-row>

<assessment-row title="Generalized Non-Pitting Edema">
  <p>{{ hasGNPE }}</p>
</assessment-row>

<h2>Pitting Edema</h2>
<assessment-row title="Right Hand">
  <p>{{ data.rightHand }}</p>
</assessment-row>

<assessment-row title="Right Foot">
  <p>{{ data.rightFoot }}</p>
</assessment-row>

<assessment-row title="Left Foot">
  <p>{{ data.leftFoot }}</p>
</assessment-row>

<assessment-row title="Left Hand">
  <p>{{ data.leftHand }}</p>
</assessment-row>

<assessment-row title="Generalized Perfusion">
  <p>{{ data.generalizedPerfusion }}</p>
</assessment-row>

<assessment-row title="Cap Refill">
  <p>{{ isNormalCapRefill }}</p>
</assessment-row>

<h2>Pulses</h2>
<assessment-row title="RUE">
  <p>{{ data.pulseRue }}</p>
</assessment-row>
<assessment-row title="RLE">
  <p>{{ data.pulseRue }}</p>
</assessment-row>
<assessment-row title="LUE">
  <p>{{ data.pulseRue }}</p>
</assessment-row>
<assessment-row title="LLE">
  <p>{{ data.pulseRue }}</p>
</assessment-row>

<assessment-row title="Cyanosis">
  <p>{{ data.cyanosisNoted}}</p>
</assessment-row>

<assessment-row title="Pacemaker">
  <p> {{isPaceMaker}} </p>
</assessment-row>

@if (isPaceMaker) {
<assessment-row title="Pacemaker Comment">
  <p>{{ data.pacemakerComment }}</p>
</assessment-row>
}